namespace TabAurous.Common {
    export enum AdditionalChargesType {
        Product = 1,
        Transaction = 2
    }
    Serenity.Decorators.registerEnumType(AdditionalChargesType, 'TabAurous.Common.AdditionalChargesType', 'Master.AdditionalChargesType');
}
